import React from "react";
import image1 from "../../assets/images/project-1/image1.png";
import image2 from "../../assets/images/project-1/image2.png";
import image3 from "../../assets/images/project-1/image3.png";
import image4 from "../../assets/images/project-1/image4.png";

const MoneyManager = () => {
  return (
    <div>
      {/* The button to open modal */}

      {/* Put this part before </body> tag  */}
      <input type="checkbox" id="money-project-modal" class="modal-toggle" />
      <div class="modal modal-bottom sm:modal-middle">
        <div class="modal-box sm:max-w-xl lg:max-w-4xl">
          <label
            for="money-project-modal"
            class="btn btn-sm border-0 btn-circle absolute right-2 top-2"
          >
            ✕
          </label>
          <h3 class="font-semibold text-2xl text-center">Money Manager</h3>
          <p class="py-4 text-center">
            DOM based calculation website to identify costing and savings.
          </p>
          <div>
            <div class="carousel w-full">
              <div id="item1" class="carousel-item w-full">
                <img className="border" src={image1} />
              </div>
              <div id="item2" class="carousel-item w-full">
                <img className="border" src={image2} />
              </div>
              <div id="item3" class="carousel-item w-full">
                <img className="border" src={image3} />
              </div>
              <div id="item4" class="carousel-item w-full">
                <img className="border" src={image4} />
              </div>
            </div>
            <div class="flex justify-center w-full py-2 gap-2">
              <a href="#item1" class="btn btn-xs bg-[#207561] border-0">
                1
              </a>
              <a href="#item2" class="btn btn-xs bg-[#207561] border-0">
                2
              </a>
              <a href="#item3" class="btn btn-xs bg-[#207561] border-0">
                3
              </a>
              <a href="#item4" class="btn btn-xs bg-[#207561] border-0">
                4
              </a>
            </div>
            <div className="my-3">
              <h3 className="font-normal text-lg">Technology Used</h3>
              <div className="flex flex-wrap gap-2 mt-3 mb-6">
                <span class="badge md:badge-md border-[#207561] bg-white text-[#207561]">
                  HTML
                </span>
                <span class="badge md:badge-md border-[#207561] bg-white text-[#207561]">
                  CSS
                </span>
                <span class="badge md:badge-md border-[#207561] bg-white text-[#207561]">
                  Bootstrap
                </span>
                <span class="badge md:badge-md border-[#207561] bg-white text-[#207561]">
                  JavaScript
                </span>
              </div>
            </div>
            <div className="my-3">
              <h3 className="font-normal text-lg">Features</h3>
              <ul className="px-3 lg:px-6 py-4 font-light">
                <li className="" style={{ listStyleType: "disc" }}>
                  Take income value, calculate expenses and subtract from income
                  to get remaining
                </li>
                <li style={{ listStyleType: "disc" }}>
                  We can set percentage of remaining balance to save.
                </li>
                <li style={{ listStyleType: "disc" }}>
                  After saving, shows remaining balance.
                </li>
                <li style={{ listStyleType: "disc" }}>
                  Input validation added for all input fields
                </li>
              </ul>
            </div>
          </div>
          <div class="py-3 text-center md:text-left">
            <a
              href="https://money-savings-planner.netlify.app/"
              target="_blank"
              class="btn font-medium btn-sm bg-[#207561]"
            >
              Live View
            </a>
            <a
              href="https://github.com/devnoman01/money-savings-planner"
              target="_blank"
              class="btn font-medium btn-sm bg-[#207561] mx-3"
            >
              Repo
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoneyManager;
